// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cn: CountryValidator<"JP"> = createValidator(
  "jp.cn",
  107,
);

export default cn;
export const compact = cn.compact;
export const format = cn.format;
export const validate = cn.validate;
export const generate = (): string =>
  cn.generate?.() ??
  (() => {
    throw new Error(
      "Validator jp.cn cannot generate values",
    );
  })();
